<template>
  <v-app>
    <v-content>
      <router-view />
      <CookieAlert />
    </v-content>
  </v-app>
</template>

<script>
import '@mdi/font/css/materialdesignicons.css';
import CookieAlert from './components/CookieAlert.vue';

export default {
  name: 'App',
  components: {
    CookieAlert,
  },
};
</script>
